import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleProp, StyleSheet, TextStyle } from 'react-native';
import { useTheme } from 'react-native-paper';

import { HoverableButton, OEText } from '..';
import type { TopMenuItem } from '../../molecules/top-menu/top-menu';
import { color } from '../../style-utils';

export function TopMenuLink({
  name,
  onPress,
  containerStyle,
  textStyle,
  hoveredTextStyle,
}: TopMenuItem) {
  const { colors } = useTheme();

  const _textStyle: StyleProp<TextStyle> = [styles.textStyle, textStyle];

  const _hoveredTextStyle: StyleProp<TextStyle> = [
    styles.textStyle,
    color(colors.primary),
    hoveredTextStyle,
  ];

  return (
    <StyledLink onPress={onPress} containerStyle={containerStyle}>
      {(isHovered) => (
        <OEText style={isHovered ? _hoveredTextStyle : _textStyle}>
          {name}
        </OEText>
      )}
    </StyledLink>
  );
}

const StyledLink = styled(HoverableButton)`
  margin: 0 8px;
`;

const styles = StyleSheet.create({
  textStyle: {
    fontSize: 16,
    fontWeight: '600',
  },
});
